import ApiClient from "@common/api/ApiClient";

/**
 * Class representing a client for customer interactions.
 * Extends the ApiClient to provide specific functionalities for API requests.
 *
 * @extends ApiClient
 */
class CustomerInteractionClient extends ApiClient {
  /**
   * Create a CustomerInteractionClient.
   * Initializes the API client with the "CustomerInteraction" route and sets the API URL key.
   */
  constructor() {
    super("CustomerInteraction");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async (payload) => await this.get("Create", payload);

  Create = async (payload) => await this.post("Create", payload);

  ReadForSearch = async (payload = {}) => await this.get("Search", payload);

  Search = async (payload = {}) => await this.post("Search", payload);

  ReadForUpdate = async (id) =>
    await this.get(`Update?id=${id}&includeImages=true&includeThumbnails=true`);

  Read = async (id) => {
    const record = await this.get(
      `Read?id=${id}&includeImages=true&includeThumbnails=true`,
    );
    return { record };
  };

  Update = async (payload) => await this.post("Update", payload);
}

const client = new CustomerInteractionClient();

export default client;
